module.exports = __webpack_public_path__ + "img/grouped_column.1694b8e1.svg";